import script from "./GameCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./GameCategory.vue?vue&type=script&setup=true&lang=js"

import "./GameCategory.vue?vue&type=style&index=0&id=47f93679&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f93679"]])

export default __exports__